import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { CurrencyInfo } from './currencies.types'

export const getCurrencies: QueryFn<[string], CurrencyInfo[]> = async client => {
  const { data } = await client.get<{ data: CurrencyInfo[] }>('v1/currencies')

  return data.data
}
